import styled from "styled-components";
import { Input } from 'antd';
export const TreeWrapper = styled.div`
display:flex;
flex-direction:column;
  .ant-input-focused {
    border: 1px solid #0C53BB !important;
    box-shadow: none;
  }

  /* Tighter horizontal rhythm so deeply nested nodes don't push labels off-panel. */
  .ant-tree .ant-tree-indent-unit {
    width: 14px;
  }

  .ant-tree .ant-tree-switcher {
    width: 18px;
    line-height: 22px;
  }

  .ant-tree .ant-tree-node-content-wrapper {
    padding: 0 2px;
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .ant-tree .ant-tree-iconEle {
    margin-right: 4px;
  }

  .ant-tree-treenode-selected {
    width: 100%;
    background: #F1F6FE;
    border-left: 2px solid #0C53BB;
  }

  /* Live drag-and-drop destination: the folder row a dragged document will
     land in (resolved by documentMoveUtils.resolveDragoverFolderKey — the
     same logic the drop handler uses, so the highlight never lies). */
  .dms-tree-drop-target {
    background: #E3EEFD;
    outline: 1.5px solid #0C53BB;
    outline-offset: -1.5px;
    border-radius: 4px;
  }

  /* Suppress rc-tree's reorder-style gap indicator line — gap drops here
     mean "into the containing folder", not "between rows", so the line
     would suggest an ordering semantic the tree doesn't have. */
  .ant-tree-drop-indicator {
    display: none;
  }

  .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: #F1F6FE;
  }

  .ant-tree-title {
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #48566B;
    overflow: hidden;
    font-family: 'Manrope', sans-serif !important;
    font-size: 13px;
    line-height: 20px;
  }
  .MuiBox-root{
  width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display:block
  }
    .ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle {
    display:flex;
    align-items:center;
}
`
export const SearchWrapper = styled.div`
margin-bottom: 16px;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyledSearchInput = styled(Input)`
  border-radius: 6px;
  padding-left: 35px; /* Leave space for custom icon */
&:focus {
    //outline: none;
    border: 1px solid #0C53BB;
  } 
    &:hover {
    //outline: none;
    border: 1px solid #0C53BB;
  } 
`;
export const NoDataContainer = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0px;
  color: #48566B;
  padding: 5px;
`;

